import { render, staticRenderFns } from "./SidebarLogo.vue?vue&type=template&id=7aedf59d&scoped=true&"
import script from "./SidebarLogo.vue?vue&type=script&lang=ts&"
export * from "./SidebarLogo.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarLogo.vue?vue&type=style&index=0&id=7aedf59d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aedf59d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aedf59d')) {
      api.createRecord('7aedf59d', component.options)
    } else {
      api.reload('7aedf59d', component.options)
    }
    module.hot.accept("./SidebarLogo.vue?vue&type=template&id=7aedf59d&scoped=true&", function () {
      api.rerender('7aedf59d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/layout/components/Sidebar/SidebarLogo.vue"
export default component.exports